export default class ProductService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllProducts(args) {
    return this.axiosIns.get(this.serviceConfig.products, { params: args });
  }

  createProduct(...args) {
    return this.axiosIns.post(this.serviceConfig.products, ...args);
  }

  editProduct(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.products}/${id}`, args);
  }

  getProduct(productId) {
    return this.axiosIns.get(`${this.serviceConfig.products}/${productId}`);
  }

  deleteProduct(id) {
    return this.axiosIns.delete(`${this.serviceConfig.products}/${id}`);
  }
}
